module.exports = __webpack_public_path__ + "static/media/ic_player_minus_15.e45e6f0e.svg";